<template>
  <div class="content-item">
    <h2 class="heading">Church Phone Number</h2>
    <p class="text">This will be listed on the card</p>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <input v-model="areaCode" type="text" class="form-input" placeholder="Area Code" />
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <input v-model="phoneNumber" type="text" class="form-input" placeholder="Phone Number" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step7',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      areaCode: '',
      phoneNumber: '',
    };
  },
  methods: {
    submit() {
      this.$emit('input', {
        ...this.value,
        church_phone: `${this.areaCode} ${this.phoneNumber}`,
      });
    },
  },
};
</script>

<style lang="scss"></style>
